<template>
  <div class="CountBox">
    <div class="Denglu">
      <span class="GongName"
        >欢迎来到鸿心智行（天津）数字科技有限公司商城！</span
      >
      <span class="DengText">登录<span class="Icons">|</span> 注册</span>
    </div>
    <div class="headerBox">
      <div class="HeaderImg">
        <input type="text" v-moudle="textinput" class="Inputtext" />
      </div>
    </div>
    <div class="centerBox">
      <div class="Top_One">
        <div class="Lists_tab">
          <div class="Name" v-for="item of List_Tab" :key="item.id">
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="CountImg">
        <div class="LeftBox">
          <img src="../../public/images/left_top.png" class="left_top" alt="" />
          <img
            src="../../public/images/left_bottom.png"
            class="left_bottom"
            alt=""
          />
        </div>
        <div class="RightBox">
          <img
            src="../../public/images/center_img.png"
            class="center_img"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="FooterBox">
      <div class="text" @click="ChangePage">
        <img src="../../public//images/laba.png" class="labaBox" />
        <span class="textbox"
          >关于我司取消药品网络交易第三方平台备案通知公告</span
        >
      </div>
      <span
        >Copyright ©2023.鸿心智行(天津)数字科技有限公司All Rights
        Reserved.|备案号:津ICP备2024021039号-1</span
      >
      <span style="margin-top: 15px"
        >联系方式:186309876961地址:天津市蓟州区渔阳镇兴华商务中心C区305、306室</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      textinput: "",
      List_Tab: [
        {
          id: 1,
          name: "首页",
        },
        {
          id: 2,
          name: "紧固件圈",
        },
        {
          id: 3,
          name: "螺丝批圈",
        },
        {
          id: 4,
          name: "开口扳手圈",
        },
        {
          id: 5,
          name: "套筒组套圈",
        },
        {
          id: 6,
          name: "商家入驻",
        },
        {
          id: 7,
          name: "信息发布",
        },
      ],
    };
  },
  methods: {
    ChangePage() {
      window.open(
        "/pdf/鸿心智行-药品网络交易第三方平台备案取消公示.pdf",
        "_blank"
      );
    },
  },
};
</script>

<style scoped>
.CountBox {
  width: 100%;
  height: 100%;
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
  padding-bottom: 170px;
}
.Denglu {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #d4d4d499;
  padding-left: 180px;
  padding-right: 230px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Denglu .GongName {
  font-size: 14px;
  color: rgb(87, 87, 87);
}
.Denglu .DengText {
  font-size: 14px;
  color: rgb(87, 87, 87);
  cursor: pointer;
}
.Denglu .DengText .Icons {
  font-size: 14px;
  margin: 0px 15px;
}

.headerBox {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.HeaderImg {
  width: 85%;
  height: 120px;
  background-image: url("../../public/images/header.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.Inputtext {
  width: 39.2%;
  height: 40px;
  position: absolute;
  top: 32%;
  left: 27%;
  border: none;
}

.centerBox {
  /* width: 100%;
  height: 100%; */
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
}
.Top_One {
  width: 100%;
  height: 80px;
  background-color: #333333;
  padding-left: 220px;
  box-sizing: border-box;
}
.Lists_tab {
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.Lists_tab .Name {
  font-size: 18px;
  color: #ffffff;
  font-weight: bold;
  margin-right: 95px;
  cursor: pointer;
}

/* .Lists_tab .Name:hover {
  color: red;
} */

/* 中间图片部分 */
.CountImg {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  padding-top: 30px;
  box-sizing: border-box;
}
.CountImg .LeftBox {
  width: 450px;
  display: flex;
  flex-direction: column;
}
.CountImg .RightBox {
  width: 55%;
  height: 550px;
  margin-left: 30px;
}

.CountImg .LeftBox .left_top {
  display: block;
  width: 100%;
  height: 265px;
  margin-bottom: 20px;
}
.CountImg .LeftBox .left_bottom {
  display: block;
  width: 100%;
  height: 265px;
}

.CountImg .RightBox .center_img {
  width: 100%;
  height: 100%;
}

.FooterBox {
  width: 100%;
  height: 150px;
  padding-left: 150px;
  position: fixed;
  bottom: 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  color: #3030309c;
  background-color: #ffffff;
}

.text {
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 15px;
}

.text:hover {
  color: red;
}
.labaBox {
  width: 25px;
  height: 25px;
  margin: 0px 8px 0px 0px;
}
</style>
